import AdvertisementPopup from './AdvertisementPopup';

export default AdvertisementPopup;
